// Preact imports
import { h, Fragment } from 'preact';
import { useState } from 'preact/hooks';

// Component imports
import Banner from './banner';
import Overlay from './overlay';
import StyleGrid from './style-grid';
import TabGroup from './tab-group';

// Constants
const TABS = [
  { id: 1, label: 'Women' },
  { id: 2, label: 'Men' },
  { id: 3, label: 'Kids' },
];

// Helper function to check if special materials are allowed for a style
const handleSpecialMaterials = (style = '', isHoodieGraphic = '', isTankGraphic = '') => {
  let allowStyle = true;

  if ((style === 'Hooded Fleece' && isHoodieGraphic !== 'true') || (style === 'Tank' && isTankGraphic !== 'true')) {
    allowStyle = false;
  }

  return allowStyle;
};

// Helper function to categorize styles based on gender and special materials
const categorizeStyles = (styles, isHoodieGraphic, isTankGraphic) => {
  const womensStyles = [];
  const mensStyles = [];
  const kidsStyles = [];

  styles.forEach((style) => {
    if (handleSpecialMaterials(style?.name, isHoodieGraphic, isTankGraphic)) {
      switch (style?.gender) {
        case 'womens':
          womensStyles.push(style);
          break;
        case 'mens':
          mensStyles.push(style);
          break;
        case 'kids':
          kidsStyles.push(style);
          break;
        default:
          break;
      }
    }
  });

  return { womensStyles, mensStyles, kidsStyles };
};

// CustomizerStyleModal component
const CustomizerStyleModal = ({ isOpen, onClose, isKidsGraphic, isHoodieGraphic, isTankGraphic, customizerStyles }) => {
  // Return null if modal is not open
  if (isOpen) {
    // Target the Kustomer chat iFrame
    const kustomerIframe = document.querySelector('#kustomer-ui-sdk-iframe');
    if(kustomerIframe && !kustomerIframe.classList.contains("kustomer-chat-window-left")) {
      kustomerIframe.classList.add("kustomer-chat-window-left");
    }
  } else {
    const kustomerIframe = document.querySelector('#kustomer-ui-sdk-iframe');
    if(kustomerIframe && kustomerIframe.classList.contains("kustomer-chat-window-left")) {
      kustomerIframe.classList.remove("kustomer-chat-window-left");
    }

    return null;
  }

  // State for active tab
  const [activeTab, setActiveTab] = useState(1);

  // Handle tab click event
  const handleTabClick = (tabId) => setActiveTab(tabId);

  // Initialize tabs based on isKidsGraphic prop
  const initializeTabs = (kidsGraphic) => (kidsGraphic === 'true' ? TABS : TABS.slice(0, 2));

  // Categorize the customizer styles
  const categorizedStyles = categorizeStyles(Object.values(customizerStyles), isHoodieGraphic, isTankGraphic);

  // Render the CustomizerStyleModal component
  return (
    <Fragment>
      <Overlay
        isOpen={isOpen}
        onClose={onClose}
      />

      <div
        className={`js-customizerStyleModal fixed right-0 top-0 z-50 h-full w-screen max-w-[700px] overflow-y-scroll bg-white shadow-md transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}
      >
        <Banner onClose={onClose} />

        <div className="bg-white p-15">
          <TabGroup
            activeTab={activeTab}
            handleTabClick={handleTabClick}
            tabs={initializeTabs(isKidsGraphic)}
          />

          <StyleGrid
            isHidden={activeTab !== 1}
            styles={categorizedStyles.womensStyles}
          />
          <StyleGrid
            isHidden={activeTab !== 2}
            styles={categorizedStyles.mensStyles}
          />

          {isKidsGraphic === 'true' && (
            <StyleGrid
              isHidden={activeTab !== 3}
              styles={categorizedStyles.kidsStyles}
            />
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default CustomizerStyleModal;
